export default function dotsOnLargeText(text: string, limit: number) {
  const LIMIT = limit;
  const aboveLimit = text!?.length! > LIMIT;
  const dotsOrEmpty = aboveLimit ? '...' : '';

  return `${text!?.substring(0, LIMIT)}${dotsOrEmpty}`;
}
